<template>
  <v-sheet color="accent" class="py-2">
    <MarqueeText :duration="60" :paused="paused" @mouseover="pause" @mouseout="unpause">
      <div class="d-flex align-center">
        <HeaderCharacterIcon v-for="(character, i) in characters" :key="i" :id="i" :character="character"/>
      </div>
    </MarqueeText>
  </v-sheet>
</template>

<script>
import characters from '../enums/characters'
import MarqueeText from 'vue-marquee-text-component'
import HeaderCharacterIcon from './HeaderCharacterIcon'

export default {
  components: {
    MarqueeText,
    HeaderCharacterIcon
  },
  data: () => ({
    characters,
    paused: false
  }),
  methods: {
    pause () {
      this.paused = true
    },
    unpause () {
      this.paused = false
    }
  }
}
</script>
